module.exports = __webpack_public_path__ + "img/scrap-pile.556796a5.png";